import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './login.css';  // Reuse portal login styles

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const response = await axios.post('/api/login/request-reset', {
        email: email.trim().toLowerCase(),
      });

      setMessage(response.data.message || 'If this email exists, a reset link has been sent.');
      setError('');

      // Redirect to login after a short delay
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Show the server's wording. A 404 here covers "no such email" AND
        // "the account is disabled" — the second is the one that used to send
        // people round in circles, resetting a password that login would never
        // accept, so the message has to be able to say so.
        setError(
          error.response.data?.message
            || 'You have no active account on the Holiday Home Cleaning portal.'
        );
      } else {
        setError('An error occurred. Please try again.');
      }
    }
  };

  return (
    <div className="portal-login-page">
      <div className="portal-login-container">
        <div className="portal-login-card">
          <div
            className="portal-login-logo-wrapper"
            onClick={() => navigate('/login')}
            style={{ cursor: 'pointer' }}
          >
            <img
              src="/logo.png"
              alt="Holiday Home Cleaning"
              className="portal-login-logo"
            />
          </div>

          <h1 className="portal-login-title">Reset Password</h1>
          <p className="portal-login-subtitle">
            Enter your email and we&apos;ll send you a link to reset your password.
          </p>

          <form onSubmit={handleResetPassword} className="portal-login-form">
            <div className="portal-login-form-group">
              <label className="portal-login-label">Email</label>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="portal-login-input"
              />
            </div>

            <button type="submit" className="portal-login-button">
              Send Reset Link
            </button>

            {message && (
              <p className="portal-login-success-message">
                {message}
              </p>
            )}
            {error && (
              <p className="portal-login-error-message">
                {error}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;